import { Reveal, SectionLabel } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How long is a physiotherapy consultation?",
    a: "Each consultation is a focused 45-minute video call — a full movement and posture assessment, a clear diagnosis, and your personalised rehab plan before we hang up.",
  },
  {
    q: "What does a consultation cost?",
    a: "Consultation fees are confirmed when you book on WhatsApp — message us and we'll share the current rate and available slots. Strength & conditioning packages are listed above, starting at ₹4,999.",
  },
  {
    q: "What should I wear for an online session?",
    a: "Anything comfortable that lets you move freely — a t-shirt and shorts or track pants are perfect. Fitted clothing helps us see your joints and movement clearly on camera.",
  },
  {
    q: "What do I need at home for a video consult?",
    a: "A phone or laptop with a camera, a stable internet connection, and enough floor space to lie down and take a few steps. A chair and a clear wall nearby are helpful but not essential.",
  },
  {
    q: "Do I need a doctor's referral?",
    a: "No referral needed — you can book directly. If your reports, scans or prescriptions are relevant, keep them handy and we'll go through them together on the call.",
  },
  {
    q: "I'm not in your city. Can I still work with you?",
    a: "Absolutely — Physiora is fully online. Consultations, reviews and coaching all happen over video and WhatsApp, so you can join from anywhere in the world.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 md:py-36 bg-[#efe9dd] border-y border-[#E5E0D8]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionLabel>Common Questions</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-[#111111] text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight mt-6">
              Everything patients
              <span className="italic text-[#8DA37F]"> ask us first.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-7 max-w-md text-base md:text-lg leading-relaxed text-[#111111]/70">
              Something else on your mind? Message us on WhatsApp — you'll get a
              real answer from Keshav, not a bot.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`faq-${i}`}
                  className="border-b border-[#E5E0D8]"
                >
                  <AccordionTrigger
                    data-testid={`faq-question-${i}`}
                    className="text-left font-display text-xl md:text-2xl font-light text-[#111111] py-6 hover:text-[#6b7f5e] hover:no-underline transition-colors duration-300"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-answer-${i}`}
                    className="text-base leading-relaxed text-[#111111]/65 pb-6 max-w-xl"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
